(() => {
  function initDpasSelection() {
    const productInfo = document.querySelector('product-info[data-bs-dpas-pending]');
    const picker = productInfo?.querySelector('variant-selects');
    if (!picker) return;

    const groups = [...picker.querySelectorAll('fieldset.product-form__input--pill')];
    const button = productInfo.querySelector('product-form .product-form__submit');
    const variantIdInput = productInfo.querySelector('product-form input[name="id"]');
    if (!groups.length || !button || !variantIdInput) return;

    const choiceNames = groups.map((group) =>
      group.querySelector('legend')?.textContent.trim().startsWith('サイズ') ? 'サイズ' : 'カラー'
    );
    const prompt = `${choiceNames.join('と')}を選択してください`;

    // Shopify renders the first variant as selected. Clear that presentation
    // and its order ID before the customer starts choosing.
    picker.querySelectorAll('input[type="radio"]:checked').forEach((input) => {
      input.checked = false;
      input.removeAttribute('checked');
    });
    variantIdInput.value = '';
    productInfo.querySelectorAll('form[id^="product-form-installment-"] input[name="id"]').forEach((input) => {
      input.value = '';
    });
    button.disabled = true;
    button.querySelector('span').textContent = prompt;
    productInfo.setAttribute('data-bs-dpas-ready', '');

    // The standard picker would fill an unchosen group with its first value.
    // Let it fetch a variant only after every displayed group has a choice.
    picker.addEventListener(
      'change',
      (event) => {
        if (groups.every((group) => group.querySelector('input[type="radio"]:checked'))) return;
        event.stopImmediatePropagation();
        event.stopPropagation();
        variantIdInput.value = '';
        button.disabled = true;
        button.querySelector('span').textContent = prompt;
      },
      true
    );

    productInfo.addEventListener(
      'submit',
      (event) => {
        if (!productInfo.hasAttribute('data-bs-dpas-pending')) return;
        if (!event.target.matches('form[data-type="add-to-cart-form"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== productInfo.dataset.section || !data.variant) return;
        productInfo.removeAttribute('data-bs-dpas-pending');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDpasSelection, { once: true });
  } else {
    initDpasSelection();
  }
})();
